// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3MWVu","signatureButtonsRight":"ModalSign_signatureButtonsRight__1vst7"};